module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0047.jpg?v=1010dafb";